import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder

const BASE = serviceName + '/learning/video'

export function getVideoPage(data) {
  return request({
    url: BASE + '/page',
    method: 'post',
    data,
  })
}

export function addVideo(data) {
  return request({
    url: BASE + '/add',
    method: 'post',
    data,
  })
}

export function updateVideo(data) {
  return request({
    url: BASE + '/update',
    method: 'post',
    data,
  })
}

export function deleteVideo(id) {
  return request({
    url: BASE + '/delete/' + id,
    method: 'post',
  })
}

export function setVideoStatus(id, status) {
  return request({
    url: BASE + '/status/' + id,
    method: 'post',
    params: { status },
  })
}